// extracted by mini-css-extract-plugin
export default {"emptyState":"Table_emptyState__Ktpg1"};